<template>
    <Modal v-if="response && typeof response === 'object'" :open="open" :show-close-icon="true" @close="closeModal" :is-card="true" :narrow="false" :close-has-background="true">
        <template slot="image">
            <a :href="response.url">
                <picture>
                    <source v-if="imageWebp" media="(min-width: 768px)" :srcset="imageWebp" type="image/webp">
                    <source v-if="imageJpeg" media="(min-width: 768px)" :srcset="imageJpeg" type="image/jpeg">
                    <source v-if="imageWebpXs" :srcset="imageWebpXs" type="image/webp">
                    <img ref="image" class="modal__image" alt="" :src="response.homepage_banner_xs_image_jpg" :srcset="imageJpegXs">
                </picture>
            </a>
        </template>
        <template slot="banner" v-if="response.banner_text">
            <h4 class="modal__banner-text">{{ response.banner_text }}</h4>
        </template>

        <template slot="header">
            <h2 class="cms-offer-modal__title">{{ response.title }}</h2>
        </template>

        <template slot="body">
            <div class="modal__body" v-html="response.preview"></div>
        </template>

        <template slot="buttons">
            <a @click="openOffer" target="_blank" :href="response.url" class="btn btn--primary btn--full-width modal__btn">Discover Offer</a>
        </template>
    </Modal>
</template>

<script>
import axios from 'axios';
import Modal from '../../core/components/Modal.vue';
import { mapState } from 'vuex';
import { customEvent } from "../../modules/tracking/AnalyticsEvents";


export default {
    components: {
        Modal,
    },
    data() {
        return {
            open: false,
            response: null,
            manuallyClosed: false 
        };
    },
    methods: {
        closeModal() {
            this.open = false;
            this.manuallyClosed = true; 
            customEvent({
                category: "Configurator Pop Out",
                action: "Close Pop Out",
                label: "X button",
            });
        },
        openModal() {
            if (!this.response || !typeof this.response === 'object') {
                return;
            } else if (typeof this.response === 'object' && Object.keys(this.response).length > 0 && !this.manuallyClosed) {
                this.open = true;
                customEvent({
                    category: "Configurator Pop Out",
                    action: "Appears",
                    label: this.model.name + ' ' + this.trimChoice + ' Pop Out',
                });
            }    
        },
        openOffer(){
            customEvent({
                category: "Configurator Pop Out",
                action: "Clicked",
                label: "Pop Out Discover Offer CTA",
            });
        }
    },
    computed: {
        ...mapState(['model', 'trimChoice']),
        imageJpegXs() {
            if (!this.response.homepage_banner_xs_image_jpg_2x)
                return `${this.response.homepage_banner_xs_image_jpg} 1x`;
            else if (!this.response.homepage_banner_xs_image_jpg)
                return `${this.response.homepage_banner_xs_image_jpg_2x} 2x`;
            else
                return `${this.response.homepage_banner_xs_image_jpg} 1x, ${this.response.homepage_banner_xs_image_jpg_2x} 2x`;
        },
        imageWebpXs() {
            if (!this.response.homepage_banner_xs_image_webp_2x)
                return `${this.response.homepage_banner_xs_image_webp} 1x`;
            else if (!this.response.homepage_banner_xs_image_webp)
                return `${this.response.homepage_banner_xs_image_webp_2x} 2x`;
            else
                return `${this.response.homepage_banner_xs_image_webp} 1x, ${this.response.homepage_banner_xs_image_webp_2x} 2x`;
        },
        imageJpeg() {
            if (!this.response.homepage_banner_image_jpg_2x)
                return `${this.response.homepage_banner_image_jpg} 1x`;
            else if (!this.response.homepage_banner_image_jpg)
                return `${this.response.homepage_banner_image_jpg_2x} 2x`;
            else
                return `${this.response.homepage_banner_image_jpg} 1x, ${this.response.homepage_banner_image_jpg_2x} 2x`;
        },
        imageWebp() {
            if (!this.response.homepage_banner_image_webp_2x)
                return `${this.response.homepage_banner_image_webp} 1x`;
            else if (!this.response.homepage_banner_image_webp)
                return `${this.response.homepage_banner_image_webp_2x} 2x`;
            else
                return `${this.response.homepage_banner_image_webp} 1x, ${this.response.homepage_banner_image_webp_2x} 2x`;
        },
    },
    mounted() {
        setTimeout(() => {
            axios.get(`/api/configurator/offer/${this.model.id}/${this.trimChoice}`)
                .then((response) => {
                    this.response = response.data;
                    if(typeof this.response  === 'object' && Object.keys(this.response).length > 0){
                        this.openModal()
                    } 
                })
                .catch((error) => {
                    console.log(error);
                });
        }, 2000);
    },


}
</script>

<style lang="scss">
.modal {
    &__container{
        width: 40%;
        text-align: center;
        @media (max-width: 992px) {
            width: 85%;
        }
    }

    &__banner-text{
        color: rgba(255, 255, 254, 1);
        width: 100%;
        font-size: 16px;
        word-wrap: break-word;
    }
    &__body{
        display: flex;
        justify-content: center;
        p{
            text-align: center;
            width: 60%;
            @media (max-width: 992px) {
                width: 100%;
            }
        }
      
    }
    &__inner {
        display: flex;
        justify-content: center;
        flex-direction: column;
    
        * + * {
            margin-top: 8px;
        }
    }

    &__close-icon {
        margin-top: 0;
    }

    &__image {
        max-width: 100%;
        display: block;
    }
    &__btn{
        width: 50%;
        text-transform: none;
        @media (max-width: 992px) {
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/components/CMSOfferModal.vue